import { ModuleWithProviders, NgModule } from '@angular/core';
import { LoginService } from './services/login/login.service';
import { AssetService } from './services/asset/asset.service';
import { PlatformService } from './services/platform/platform.service.interface';
import { PlatformServiceImpl } from './services/platform/platform.service';
import { StorageService } from './services/storage/storage.service.interface';
import { StorageServiceImpl } from './services/storage/storage.service';
import { ApolloService } from './services/apollo/apollo.service';
import { LoginGuardService } from '@src/app/services/login-guard/login-guard.service';
import { MfaAuthenticatedGuardService } from '@src/app/services/login-guard/mfa-authenticated-guard.service';
import { RouterService } from '@src/app/services/router/router.service.interface';
import { RouterServiceImpl } from '@src/app/services/router/router.service';
import { ScopeService } from '@src/app/services/scope/scope.service';
import { PermissionsService } from '@src/app/services/permissions/permissions.service';
import {
  ApolloServiceConfig,
  createApolloServiceConfig,
  loadApolloConfig,
} from '@src/app/configs/apollo.service.config';
import { createLoginServiceConfig, LoginServiceConfig } from '@src/app/configs/login.service.config';
import { AssetServiceConfig, createAssetServiceConfig } from '@src/app/configs/asset.service.config';
import { EnvironmentConfig } from '@src/app/configs/environment.config';
import { provideApollo } from 'apollo-angular';

@NgModule({
  imports: [],
  exports: [],
  providers: [
    LoginService,
    ScopeService,
    PermissionsService,
    LoginGuardService,
    AssetService,
    MfaAuthenticatedGuardService,
    { provide: RouterService, useClass: RouterServiceImpl },
    { provide: StorageService, useClass: StorageServiceImpl },
    { provide: PlatformService, useClass: PlatformServiceImpl },
    provideApollo(loadApolloConfig),
  ],
})
export class CoreModule {
  // https://www.bennadel.com/blog/3565-providing-module-configuration-using-forroot-and-ahead-of-time-compiling-in-angular-7-2-0.htm
  static forRoot(): ModuleWithProviders<CoreModule> {
    return ({
      ngModule: CoreModule,
      providers: [
        {
          provide: LoginServiceConfig,
          useFactory: createLoginServiceConfig,
          deps: [EnvironmentConfig], // EnvironmentConfig is provided ahead of time in main.ts!
        },
        {
          provide: ApolloServiceConfig,
          useFactory: createApolloServiceConfig,
          deps: [EnvironmentConfig],
        },
        {
          provide: AssetServiceConfig,
          useFactory: createAssetServiceConfig,
          deps: [EnvironmentConfig],
        },
      ],
    });
  }
}
